export default [
  {
    path: "/otherOrder/otherPay",
    name: "otherPay",
    meta: {
      title: "下单支付",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/otherOrder/otherPay")
  },
  {
    path: "/otherOrder/otherOrderDetail",
    name: "otherOrderDetail",
    meta: {
      title: "订单详情",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/otherOrder/otherOrderDetail")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/otherOrder.js